import { FC } from "react";
import {
  Control,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
  Controller,
} from "react-hook-form";
import FormGroup from "app/components/common/inputs/FormGroup";
import EmploymentTypeSelector from "app/components/common/EmploymentTypeSelector";
import CustomDatePicker from "app/components/common/inputs/CustomDatePicker";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import RadioButton from "app/components/common/buttons/RadioButton";

interface Props {
  control: Control<any>;
  errors: any;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  watch: UseFormWatch<any>;
  joiningDate: string;
  employmentType: string;
  previousemployer: string;
  showEmploymentType: boolean;
  hasSecondJob: string;
  hasSecondjobName: string;
}

const DynamicFormTwo: FC<Props> = ({
  control,
  errors,
  register,
  setValue,
  joiningDate,
  employmentType,
  previousemployer,
  showEmploymentType,
  watch,
  hasSecondJob,
  hasSecondjobName,
}) => {
  const getErrorMessage = (fieldName: string) => {
    const fieldNames = fieldName.split(".");
    return fieldNames.reduce((acc, key) => acc && acc[key], errors);
  };

  return (
    <>
      <FormGroup>
        <CustomDatePicker
          name={joiningDate}
          control={control}
          label="Joining date"
          placeholder="DD/MM/YYYY"
          rules={{ required: "Date is required" }}
          className="flex-1"
          isPastDate={true}
          maxDate={new Date()} // ✅ Disable future dates
        />
      </FormGroup>
      <div className="text-left mb-3">
        <p className="font-Mulish text-[14px] text-[#98A2B3]">
          If you are currently employed for less than 12 months, please provide
          details regarding previous employer
        </p>
      </div>
      {showEmploymentType && (
        <EmploymentTypeSelector
          name={employmentType}
          register={register}
          setValue={setValue}
          watch={watch}
          errors={errors}
        />
      )}

      <div className="text-left mb-5">
        <h6 className="font-Mulish text-nowrap text-[16px] text-[#585C7B] mb-4">
          Do you have any previous employer?
        </h6>
        <div className="flex gap-5">
          <Controller
            name={previousemployer}
            control={control}
            rules={{ required: "Please select an option" }}
            render={({ field: { value, onChange } }) => (
              <div className="flex gap-5">
                <RadioButton
                  id={`yes-${previousemployer}`}
                  name={previousemployer}
                  value="yes"
                  label="Yes"
                  checked={value === "yes"}
                  onChange={onChange}
                />
                <RadioButton
                  id={`no-${previousemployer}`}
                  name={previousemployer}
                  value="no"
                  label="No"
                  checked={value === "no"}
                  onChange={onChange}
                />
              </div>
            )}
          />
        </div>

        <ErrorsMessage
          title={getErrorMessage(previousemployer)?.message as string}
          className="!text-left"
        />
      </div>
      {hasSecondJob === "no" && (
        <div className="text-left mb-5">
          <h6 className="font-Mulish text-nowrap text-base text-[#585C7B] mb-4">
            Do you have a second job?
          </h6>
          <div className="flex gap-5">
            <Controller
              name={hasSecondjobName}
              control={control}
              rules={{ required: "Please select an option" }}
              render={({ field: { value, onChange } }) => (
                <div className="flex gap-5">
                  <RadioButton
                    id={`job-yes-${hasSecondjobName}`}
                    name={hasSecondjobName}
                    value="yes"
                    label="Yes"
                    checked={value === "yes"}
                    onChange={onChange}
                  />
                  <RadioButton
                    id={`job-no-${hasSecondjobName}`}
                    name={hasSecondjobName}
                    value="no"
                    label="No"
                    checked={value === "no"}
                    onChange={onChange}
                  />
                </div>
              )}
            />
          </div>

          <ErrorsMessage
            title={getErrorMessage(hasSecondjobName)?.message as string}
            className="!text-left"
          />
        </div>
      )}
    </>
  );
};

export default DynamicFormTwo;
